export class CustomersService {
    constructor(axios, apiUrl) {
      this.$axios = axios;
      this.apiUrl = apiUrl;
    }

    async getCustomerByInfo(id, lastName, zip) {
      return await this.$axios.get(this.apiUrl + `Customers/Customer/${id}?lastName=${lastName}&zip=${zip}`).then(function(response) {
        /* Try to assemble address1, if not provided. */
        if (response.data && !response.data.address1) {
          response.data.address1 = `${(response.data.streetNo ?? "").trim()} ${(response.data.predir ?? "").trim()} ${(response.data.streetNm ?? "").trim()} ${(response.data.suffix ?? "").trim()} ${(response.data.postDir ?? "").trim()}`.trim();
        }

        return response.data;
      })
      .catch(function(error) {
          return {error: error, response: error.response.data };
      });
    }

    async getCustomerById(id, sqldbid) {
        return await this.$axios.get(this.apiUrl + `Customers/Customer/${id}/Company/${sqldbid}`).then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            return {error: error, response: error.response?.data };
        });
    }

    async updateCustomerById(id, sqldbid, customerData) {
        return await this.$axios.patch(this.apiUrl + `Customers/Customer/${id}/Company/${sqldbid}`, customerData).then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            return {error: error, response: error.response.data };
        });
    }

    /**
     * 
     * @param {*} id 
     * @param {*} sqldbid 
     */
    async getCustomerPaymentHistory(id, sqldbid, data) {
      return await this.$axios.post(this.apiUrl + `Customers/Customer/${id}/Company/${sqldbid}/History/Search`, {
        data
      }).then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        return {error: error, response: error.response.data };
      });
    }

    async updateCustomerInformation(id, sqldbid, data) {
      return await this.$axios.patch(this.apiUrl + `Customers/Customer/${id}/Company/${sqldbid}`, 
        data
      ).then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        return {error: error, response: error.response.data };
      });  
    }

    async updateCustomerInformationEdit(data, sessionId) {
      return await this.$axios.put(this.apiUrl + `Customers/Customer/Information`, 
        data,
        {
          headers: {
            'X-SessionId': sessionId,
          }
        }
      ).then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        return {error: error, response: error.response.data };
      });
    }

    async allocatePrepay(sqldbid, customerNumber, prepayCode, progIds, sessionId) {
      return await this.$axios.post(this.apiUrl + `Customers/Company/${sqldbid}/PrepayAllocation`,
        {
          customerNumber: customerNumber,
          prepayCode: prepayCode,
          progIds: progIds,
          empId: "SGCAPI",
        },
        {
          headers: {
            'X-SessionId': sessionId,
          }
        }
      ).then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        return {error: error, response: error.response.data };
      });
    }
}
